module.exports = __webpack_public_path__ + "img/jm-tip.f5c36567.png";